import ContentContainer from "../ContentContainer";
import SideNavigation from "./SideNavigation";
import TopNavigation from "./TopNavigation";

type MainLayoutProps = {
    isLoading?: boolean;
    children: React.ReactNode;
};

const MainLayout = ({ isLoading, children }: MainLayoutProps) => {
    return (
        <div className="w-full min-h-screen bg-surface-light">
            <TopNavigation />
            <SideNavigation />
            <main className="pb-[4.563rem] sm:pb-0 sm:pl-[4.563rem] pt-14">
                {isLoading ? (
                    <ContentContainer className="py-10 text-center">
                        Loading...
                    </ContentContainer>
                ) : (
                    children
                )}
            </main>
        </div>
    );
};

export default MainLayout;
